var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data !== null
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "header-wrapper" }, [
                  _c("h2", { staticClass: "text-primary-fh text-left" }, [
                    _vm._v("Provresultat för minderårigt barn "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.currentChild
                      ? _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.currentChild.firstName +
                                " " +
                                _vm.currentChild.lastName
                            )
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("br"),
                  _c("br")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card dashboard-card" }, [
                  _c("h5", { staticClass: "text-primary-fh left-header" }, [
                    _vm._v("Provsvar")
                  ]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.data.dashboard.labresultsCardTextMinor
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("small", { staticClass: "text-right" }, [
                    _vm._v(_vm._s(_vm.getTestDate(_vm.bloodTest)))
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass:
                        "ul-list list-group list-group-flush bg-transparent"
                    },
                    [
                      _c(
                        "li",
                        { staticClass: "list-group-item bg-transparent" },
                        [
                          _vm._v("\n                Totalkolesterol "),
                          _vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.bloodTest.totalKolesterol) +
                                      " " +
                                      _vm._s(
                                        _vm.bloodTest.totalKolesterolUnit
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [_vm._v("-")]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "list-group-item bg-transparent" },
                        [
                          _vm._v("\n                Triglycerider "),
                          _vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.bloodTest.triglycerider) +
                                      " " +
                                      _vm._s(_vm.bloodTest.triglyceriderUnit) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [_vm._v("-")]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "list-group-item bg-transparent" },
                        [
                          _vm._v("\n                HDL kolesterol "),
                          _vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.bloodTest.hdl) +
                                      " " +
                                      _vm._s(_vm.bloodTest.hdlUnit) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [_vm._v("-")]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "list-group-item bg-transparent" },
                        [
                          _vm._v("\n                LDL kolesterol "),
                          _vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.bloodTest.ldl) +
                                      " " +
                                      _vm._s(_vm.bloodTest.ldlUnit) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [_vm._v("-")]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "list-group-item bg-transparent" },
                        [
                          _vm._v("\n                Lipoprotein (a) "),
                          _vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.bloodTest.lipoProteinA) +
                                      " " +
                                      _vm._s(_vm.bloodTest.lipoProteinAUnit) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [_vm._v("-")]
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      staticClass:
                        "ul-list list-group list-group-flush bg-transparent"
                    },
                    [
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.data.dashboard.referenceIntervalText
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "list-group-item bg-transparent" },
                        [
                          _vm._v(
                            "\n                Totalkolesterol\n                "
                          ),
                          _vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.bloodTest
                                          .totalKolesterolReferenceInterval
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [_vm._v("-")]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "list-group-item bg-transparent" },
                        [
                          _vm._v(
                            "\n                Triglycerider\n                "
                          ),
                          _vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.bloodTest
                                          .triglyceriderReferenceInterval
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [_vm._v("-")]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "list-group-item bg-transparent" },
                        [
                          _vm._v(
                            "\n                HDL kolesterol\n                "
                          ),
                          _vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.bloodTest.hdlReferenceInterval
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [_vm._v("-")]
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "list-group-item bg-transparent" },
                        [
                          _vm._v(
                            "\n                LDL kolesterol\n                "
                          ),
                          _vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.bloodTest.ldlReferenceInterval
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.bloodTest
                            ? _c(
                                "span",
                                { staticClass: "lab-results-values" },
                                [_vm._v("-")]
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm.geneticTestData && _vm.geneticTestData.mutation
                  ? _c("div", { staticClass: "card dashboard-card" }, [
                      _c("h5", { staticClass: "text-primary-fh left-header" }, [
                        _vm._v("Resultat av ditt gentest")
                      ]),
                      _vm._v(" "),
                      _vm.geneticTestData.mutation
                        ? _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.data.dashboard.genTestMutationPositiveText
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.geneticTestData.mutation
                        ? _c("p", [
                            _vm._v(_vm._s(_vm.geneticTestData.mutation))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.geneticTestData.mutation
                        ? _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.data.dashboard.genTestMutationNegativeText
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._m(2)
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _vm.fhDiagnosis
                  ? _c("div", { staticClass: "card dashboard-card" }, [
                      _c("p", { staticClass: "text-dark" }, [
                        _c("strong", [_vm._v("Från vårdgivaren (beslut)")]),
                        _vm._v(":\n              "),
                        _c("br"),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.fhDiagnosis.patientText ||
                                "Här kommer meddelande från din vårdgivare att visas"
                            ) +
                            "\n            "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.bloodTestAssessment
                  ? _c("div", { staticClass: "card dashboard-card" }, [
                      _c("p", { staticClass: "text-dark" }, [
                        _c("strong", [_vm._v("Från vårdgivaren (provsvar)")]),
                        _vm._v(":\n              "),
                        _c("br"),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.bloodTestAssessment.patientText ||
                                "Här kommer meddelande från din vårdgivare att visas"
                            ) +
                            "\n            "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-dark btn-lg btn-block",
                    on: {
                      click: function($event) {
                        return _vm.$router.go(-1)
                      }
                    }
                  },
                  [_vm._v("← Tillbaka")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "clearfix" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "text-primary-fh left-header samplepoints-link",
        attrs: {
          href:
            "https://www.karolinska.se/for-vardgivare/karolinska-universitetslaboratoriet/klinisk-genetik/",
          target: "_blank"
        }
      },
      [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src: require("@/assets/img/external-link.svg?data"),
            alt: "Ikon för extern länk"
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v(" Läs mer om genmutationer")])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5974219e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5974219e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardMinor.vue
// module id = null
// module chunks = 